// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"InterestListFilters_filterWrapper__tBWOD"};